module.exports = __webpack_public_path__ + "static/media/debateImage2.eb27c935.png";